import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./partials/Header.comp";
import { Menu } from "./partials/Menu.comp";

export const DefaultLayout = ({ children }) => {
  return (
    <div className="default-layout">
      <header className="main-header">
        <Header />
      </header>
      <div className="main-container">
        <aside className="sidebar">
          <Menu/>
        </aside>
        <main className="content">
          <div className="changeable-content">
            {children ? children : <Outlet />}
          </div>
        </main>
      </div>
      {/* <footer className="footer">
        <Footer />
      </footer> */}
    </div>
  );
};
